<template>
  <div>
    <div class="display-flex align-center justify-space-between">
      <span class="text-dmsans-14 text-grey-2">Subtotal</span>
      <span class="text-dmsans-15">$519.96</span>
    </div>

    <div class="display-flex align-center justify-space-between my-1">
      <span class="text-dmsans-14 text-grey-2">Stripe Fee</span>
      <span class="text-dmsans-15">$7.70</span>
    </div>

    <div class="display-flex align-center justify-space-between">
      <span class="text-dmsans-14 text-grey-2">Tax</span>
      <span class="text-dmsans-15">$37.69</span>
    </div>

    <hr class="my-3" />

    <div class="display-flex align-center justify-space-between">
      <span class="text-dmsans-16">Grand Total </span>
      <span class="text-dmsans-16">$565.35</span>
    </div>

    <v-btn
      class="text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4"
    >
      <img
        src="../../../assets/mobile/icon/apple-pay.svg"
        width="58"
        height="24"
      />
    </v-btn>

    <div
      class="text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
    >
      <hr class="flex-grow" />
      <span class="mx-2">Or pay with card</span>
      <hr class="flex-grow" />
    </div>

    <div class="text-dmsans-14 font-weight-700 mb-2">Credit card</div>

    <div class="credit-card mb-5">
      <div class="display-flex align-center px-3 credit-card__number">
        <input
          type="text"
          placeholder="1234 1234 1234 1234"
          class="full-width border-none"
        />
        <div class="display-flex align-center gap-8">
          <img
            src="../../../assets/mobile/icon/visa.svg"
            width="24"
            height="16"
          />
          <img
            src="../../../assets/mobile/icon/master-card.svg"
            width="24"
            height="16"
          />
          <img
            src="../../../assets/mobile/icon/american-express.svg"
            width="24"
            height="16"
          />
          <img
            src="../../../assets/mobile/icon/discover.svg"
            width="24"
            height="16"
          />
        </div>
      </div>
      <div class="display-flex align-center full-width">
        <input
          type="text"
          placeholder="MM / YY"
          class="border-none width-50 credit-card__month px-3 credit-card__month"
        />
        <div class="width-50 px-3 display-flex align-center">
          <input type="text" placeholder="CVC" class="border-none full-width" />
          <img
            src="../../../assets/mobile/icon/card.svg"
            width="24"
            height="16"
          />
        </div>
      </div>
    </div>

    <div class="text-dmsans-14 font-weight-700 mb-2">Country or region</div>

    <div class="mb-4 country-region">
      <v-select
        label="Choose one"
        single-line
        hide-details
        class="pt-0 country"
      ></v-select>
      <div class="zip">
        <input
          type="text"
          placeholder="ZIP"
          class="full-width border-none px-3"
        />
      </div>
    </div>

    <v-btn class="text-poppins-18 btn-confirm ma-0 full-width">
      Pay $565.35
    </v-btn>

    <div class="mt-5 display-flex justify-center">
      <img src="../../../assets/mobile/logo_stripe.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
};
</script>

<style lang="scss" scoped>
.flex-grow {
  flex-grow: 1;
}
.btn-pay {
  border-radius: 4px;
  background: #000 !important;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.08),
    0px 2px 5px 0px rgba(0, 0, 0, 0.12), 0px -1px 1px 0px rgba(0, 0, 0, 0.12);
  height: 48px;
}

.credit-card {
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(60, 66, 87, 0.12);
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04),
    0px 2px 5px 0px rgba(0, 0, 0, 0.08);
  &__number {
    border-bottom: 1px solid rgba(60, 66, 87, 0.12);
  }
  &__month {
    border-right: 1px solid rgba(60, 66, 87, 0.12) !important;
  }
}

.btn-confirm {
  color: #9b9b9b !important;
  border-radius: 84px;
  background: #000 !important;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.08),
    0px 2px 5px 0px rgba(0, 0, 0, 0.12), 0px -1px 1px 0px rgba(0, 0, 0, 0.12);
  height: 48px;
}

.zip {
  border-top: 1px solid rgba(60, 66, 87, 0.12);
}
.country-region {
  border-radius: 8px;
  border: 1px solid rgba(60, 66, 87, 0.12);
  background: #fff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04),
    0px 2px 5px 0px rgba(0, 0, 0, 0.08);
}

.country {
  /deep/.input-group__input {
    border: none !important;
  }
}
/deep/.input-group label {
  top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// card.vue?18fcd80e